import React from 'react';
import { AppConfigContext } from './AppConfig';
import type { AppProps } from './AppProps';
import { Suggestions } from './suggest/Suggestions';

export function App(props: AppProps) {
    const { isProbablyMobile, searchPlaceholder, searchTerm, ...appConfig } =
        props;

    return (
        <AppConfigContext.Provider value={appConfig}>
            <Suggestions
                isProbablyMobile={isProbablyMobile}
                searchPlaceholder={searchPlaceholder}
                searchTerm={searchTerm}
            />
        </AppConfigContext.Provider>
    );
}
